import request from '@/utils/request'

//获取产品类型
export function selectAllBusinessType() {
    return request({
      url: '/scrm/businesstype/selectAllBusinessType',
      method: 'get'
    })
  }

// 查询【客户联系人】列表
export function listType(query) {
  return request({
    url: '/scrm/businesstype/list',
    method: 'get',
    params: query
  })
}

// 查询【客户联系人】详细
export function getType(businessTypeId) {
  return request({
    url: '/scrm/businesstype/' + businessTypeId,
    method: 'get'
  })
}

// 新增【客户联系人】
export function addType(data) {
  return request({
    url: '/scrm/businesstype',
    method: 'post',
    data: data
  })
}

// 修改【客户联系人】
export function updateType(data) {
  return request({
    url: '/scrm/businesstype',
    method: 'put',
    data: data
  })
}

// 删除【客户联系人】
export function delType(businessTypeId) {
  return request({
    url: '/scrm/businesstype/' + businessTypeId,
    method: 'delete'
  })
}

// 导出【客户联系人】
export function exportType(query) {
  return request({
    url: '/scrm/businesstype/export',
    method: 'get',
    params: query
  })
}